<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <div style="margin-right: 20px">
          <span class="itemtitle">模板名称</span>
          <el-input
            v-model="tmp_name"
            size="medium"
            style="width: 220px; margin: 0 15px 0 8px"
            clearable
          ></el-input>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            size="medium"
            @click="getList"
            >查询</el-button
          >
        </div>
        <el-button
          type="primary"
          @click="addTemplate(0)"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('832') : false
          "
          size="medium"
          >新增模板</el-button
        >
      </div>
      <div style="border: solid 1px #c9cbd6; margin-top: 12px">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column prop="tmp_name" label="模板名称"></el-table-column>
          <el-table-column prop="tmp_remark" label="模板备注"></el-table-column>
          <el-table-column label="已绑定医生数">
            <template slot-scope="scope">
              <div v-if="scope.row.is_default == 0">
                {{ scope.row.doctor_count }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('832') : false
                "
                @click="addTemplate(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.is_default == 0"
                type="text"
                size="medium"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('831') : false
                "
                @click="delTemplate(scope.row.tmp_id, scope.row.doctor_count)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin: 30px 0 20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      ass_name: "",
      ass_phone: "",
      doctor_name: "",
      doctor_phone: "",
      status: "",
      bind_wx: "",
      tmp_name: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        tmp_name: this.tmp_name,
      };
      this.axios
        .post("platform/Drugtype/drugTypeTemplate", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //新增模板//编辑
    addTemplate(row) {
      if (row) {
        this.$router.push({
          path: "adddosageformtem",
          query: {
            tmp_id: row.tmp_id,
            tmp_name: row.tmp_name,
            tmp_remark: row.tmp_remark,
          },
        });
      } else {
        this.$router.push("adddosageformtem");
      }
    },
    //绑定医生
    bindDoctor() {
      this.$router.push("addtemdoctor");
    },
    //详情
    delTemplate(tmp_id, doctor_count) {
      if (doctor_count > 0) {
        this.$alert(
          "该模板已有医生使用，不可删除。请先解除已绑定医生。",
          "提示",
          {
            confirmButtonText: "确定",
          }
        );
      } else {
        this.axios
          .post("platform/Drugtype/deldrugTypeTemplate", { tmp_id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 237px);
  text-align: left;
}
.searchbox {
  display: flex;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>